module.exports = __webpack_public_path__ + "img/shipSubscrib_menu_tooltip.45c78860.svg";